import styled from 'styled-components';
import Checkbox from 'components/Checkbox';
import { sizes } from 'style';
import { th } from 'style/theme';

export const DateWrapper = styled.div`
  margin-top: 18px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media ${sizes.tabletPortrait} {
    flex-direction: row;
    gap: 16px;

    > * {
      max-width: calc(50% - 8px);
    }
  }
`;

export const StyledCheckbox = styled(Checkbox)`
  margin-top: 22px;
  color: ${th('colors.pickledBluewood1')};
  line-height: 24px;
  align-items: flex-start;

  @media ${sizes.mobileLarge} {
    align-items: center;
  }
`;
